<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>查询条件</span>
      </div>
      <div class="">
        <el-form :inline="true" :model="conditions" class="flex justify-start">
          <el-form-item>
            <el-input v-model="conditions.name" placeholder="请输入二维码名称" clearable />
          </el-form-item>
          <el-form-item>
            <el-select v-model="conditions.state" placeholder="请选择状态" clearable>
              <el-option label="启用" value="Y" />
              <el-option label="停用" value="N" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryData">
              <i class="el-icon-search"></i> 查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>收款二维码</span>
        <el-button type="primary" size="small" style="float: right;" @click="_openAddModal">
          <i class="el-icon-plus"></i>新增收款二维码
        </el-button>
      </div>
      <div class="">
        <el-table :data="list" border style="width: 100%">
          <el-table-column prop="name" label="名称" align="center" />
          <el-table-column prop="hint" label="提示语" align="center" />
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.state === 'Y' ? 'success' : 'danger'">
                {{ scope.row.state === 'Y' ? '启用' : '停用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" />
          <el-table-column label="操作" align="center" width="240">
            <template slot-scope="scope">
              <el-button size="mini" @click="_openQrCodeDialog(scope.row)">二维码</el-button>
              <el-button size="mini" @click="_openEditModal(scope.row)">修改</el-button>
              <el-button size="mini" type="danger" @click="_openDeleteModal(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
          :total="total" layout="total, prev, pager, next, jumper" style="margin-top: 20px;" />
      </div>
    </el-card>

    <add-shop-qr-code ref="addShopQrCode" @refresh="_queryData" />
    <qr-code-dialog ref="qrCodeDialog" />
  </div>
</template>

<script>
import { listShopQrCodes, deleteShopQrCode } from '@/api/phone/shopQrCodeApi'
import AddShopQrCode from '@/components/shopQrCode/AddShopQrCode'
import QrCodeDialog from '@/components/shopQrCode/QrCodeDialog'

export default {
  name: 'ShopQrCode',
  components: {
    AddShopQrCode,
    QrCodeDialog
  },
  data() {
    return {
      conditions: {
        name: '',
        state: ''
      },
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this._queryData()
  },
  methods: {
    async _queryData() {
      try {
        const res = await listShopQrCodes({
          ...this.conditions,
          page: this.currentPage,
          row: this.pageSize,
          nameLike: this.conditions.name || ''
        })
        this.total = res.total
        this.list = res.data
      } catch (error) {
        console.error('查询失败:', error)
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._queryData()
    },
    _openAddModal() {
      this.$refs.addShopQrCode.open()
    },
    _openEditModal(row) {
      this.$refs.addShopQrCode.open(row)
    },
    _openDeleteModal(row) {
      this.$confirm('确认删除该二维码配置？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await deleteShopQrCode({ qrId: row.qrId })
          if (res.code === 0) {
            this.$message.success('删除成功')
            this.currentPage = 1
            this._queryData()
          }
        } catch (error) {
          console.error('删除失败:', error)
        }
      }).catch(() => {})
    },
    _openQrCodeDialog(row) {
      this.$refs.qrCodeDialog.open(row)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>
